import styled from "@emotion/styled";

export const Price = styled.span`
  white-space: nowrap;
  padding-right: 64px;
`;
